export default "__VITE_ASSET__BPyldLZq__"